import { Card } from "@/components/ui/card";
import {
  DataTable,
  DateField,
  List,
  ListActions,
  NumberField,
  ReferenceField,
  TextField,
} from "../../common";

export const SalaryStructureList = () => (
  <List
    title="Salary Structures"
    actions={<ListActions label="Add Structure" />}
    sort={{ field: "effective_from", order: "DESC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="edit">
        <DataTable.Col label="Employee">
          <ReferenceField source="employee_id" reference="employees" link={false}>
            <TextField source="name" className="font-semibold" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col label="Component">
          <ReferenceField
            source="component_id"
            reference="hr_payroll_components"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col source="amount" label="Amount" className="text-emerald-600 font-semibold" />
        <DataTable.Col source="effective_from" label="Effective From">
          <DateField source="effective_from" />
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);

